module.exports = __webpack_public_path__ + "img/jk_icon_gerengongchengjikenormal.115cc761.png";